module.exports = __webpack_public_path__ + "img/s3.3d55036c.jpg";